module.exports = __webpack_public_path__ + "img/slogan.5f863f83.png";